module.exports = __webpack_public_path__ + "static/media/icn-delete.0e776b3a.svg";